export default __webpack_public_path__ + "static/media/BANNER FORMACION.975fc545.png";